import { render, staticRenderFns } from "./AcceptPDPA.vue?vue&type=template&id=d9acbb2e&scoped=true"
import script from "./AcceptPDPA.vue?vue&type=script&lang=js"
export * from "./AcceptPDPA.vue?vue&type=script&lang=js"
import style0 from "./AcceptPDPA.vue?vue&type=style&index=0&id=d9acbb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9acbb2e",
  null
  
)

export default component.exports